module.exports = __webpack_public_path__ + "static/media/skyp_1.bd991e16.png";